import { render, staticRenderFns } from "./groupsDeveloperPortal.vue?vue&type=template&id=2375a735"
import script from "./groupsDeveloperPortal.vue?vue&type=script&lang=js"
export * from "./groupsDeveloperPortal.vue?vue&type=script&lang=js"
import style0 from "./groupsDeveloperPortal.vue?vue&type=style&index=0&id=2375a735&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports